import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from 'reactflow';
import { OP_LABEL } from './metricTreeApi';

/**
 * OperatorEdge — a formula-decomposition edge (parent → input child). Draws the
 * connector plus an operator badge (+ − × ÷) at its midpoint, the way Mixpanel's
 * Metric Tree shows how children combine into their parent.
 *
 * data = { operator: '+'|'-'|'*'|'/' }
 */
export default function OperatorEdge({
  id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, data, markerEnd, selected,
}) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition,
  });
  const op = data?.operator;
  const glyph = OP_LABEL[op] || op;

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{ stroke: selected ? '#4f5ed1' : '#9DB0C6', strokeWidth: selected ? 2.4 : 1.8 }}
      />
      {glyph && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              width: 26,
              height: 26,
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              background: '#fff',
              border: '1.5px solid #9DB0C6',
              color: '#334155',
              fontSize: 15,
              fontWeight: 800,
              lineHeight: 1,
              boxShadow: '0 1px 2px rgba(15,26,43,0.10)',
              pointerEvents: 'all',
            }}
          >
            {glyph}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}

export const edgeTypes = { operator: OperatorEdge };
